export default __webpack_public_path__ + "static/media/Chartjs.091bd2a9.png";